"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledButton = void 0;

const styled_components_1 = __importDefault(require("styled-components"));

exports.StyledButton = styled_components_1.default.button.attrs({
  type: 'button'
})`
  border: 0;
  outline: 0;
  height: 28px;
  width: 28px;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;
  background-color: ${props => props.bgColor || props.theme.colors.white};
  color: ${props => props.textColor || props.theme.colors.primary_700_main};
  font-size: ${props => props.theme.fontSizes[12]};
  line-height: ${props => props.theme.lineHeights[16]};
  &:hover {
    box-shadow: 0px 0px 0px 4px rgba(244, 244, 244, 0.15);
  }
`;